import React from "react";
import RichTextDisplay from "@/components/widgets/richtext/RichTextDisplay";

interface PromptHeaderProps {
  name?: string;
  header?: string;
  description?: string;
  isRequired?: boolean;
  richTextDescription?: boolean;
}

export default function PromptHeader({
  name,
  header,
  description,
  isRequired = false,
  richTextDescription = true,
}: PromptHeaderProps) {
  return (
    <div className="mb-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {header || name}
        {isRequired && <span className="text-red-500"> *</span>}
      </h3>
      {description &&
        (richTextDescription ? (
          <RichTextDisplay
            content={description}
            className="prose prose-sm max-w-none"
          />
        ) : (
          <p className="text-gray-600 text-sm mb-4">{description}</p>
        ))}
    </div>
  );
}
